/**
 * A module representing notifications.
 * @module notification
 * @exports Notification
 * @see Notification
 * @requires module:helpers
 * @requires module:utils
 * @requires module:training
 * @requires module:dialog-manager
 * @example
 * var Notification = require('notification');
 */

define('notification',['helpers', 'utils', 'training', 'dialog-manager'], function(helpers, utils, Training, Dialog) {
    'use strict';

    var notifications,
        dialog,
        training;

    /**
     * @constructor
     * @alias Notifications
     * @param {Object} options
     * @param {Array} [options.answers] - User answers
     */
    function Notifications(options) {
        options = options || {};

        this.modal = options.modal || false;
        this.delay = (utils.isNumber(options.delay)) ? options.delay : 0;
        this.close = options.close || false;

        this.dataContext = options.dataContext || {};

        this.authenticationURL = options.authenticationURL || '/api/Authentication/IsAuthenticated';
        this.interval = options.interval || 60000;

        this.lang = {};

        this.modal = (this.dataContext.connection) ? !!this.dataContext.connection.modal : false;
        this.delay = (this.dataContext.connection && utils.isNumber(this.dataContext.connection.delay)) ? this.dataContext.connection.delay : 0;

        this.request = new Request(this.authenticationURL, {
            method: 'GET',
            headers: new Headers({'Authorization-Token': this.dataContext.tokenID})
        });

        this.error = this.error.bind(this);
        this.online = this.online.bind(this);
        this.offline = this.offline.bind(this);
        this.openMessage = this.openMessage.bind(this);
        this.authentication = this.authentication.bind(this);
        this.errorSCORMInit = this.errorSCORMInit.bind(this);
        this.errorSCORMComm = this.errorSCORMComm.bind(this);

        if (this.modal) {
            this.init();
        }
    }

    Notifications.prototype.setLang = function(lang) {
        this.lang = lang;
    };

    Notifications.prototype.openMessage = function(options) {
        options = options || {};

        var showClose = options.showClose !== false,
            delay = options.delay || this.delay,
            type = options.type || '',
            overlay = options.overlay || false,
            button = options.button || false;

        var notification = dialog.open({
            clone: type !== 'modal',
            container: document.getElementById('notifications'),
            content: options.content || '',
            showClose: showClose,
            overlay: overlay,
            mainClass: 'modal' + (type !== 'modal' ? ' modal-notification' : '')
        });

        if (button) {
            var buttons = [{
                action: function () { notification.close(); },
                class: 'bu bu-alt', text: this.lang.ok
            }];

            notification.addButtons(buttons);
        }

        if (delay) {
            setTimeout(function() {
               notification.close();
            }, delay);
        }
    };

    Notifications.prototype.error = function() {
        if (!this.modal) {
            return;
        }

        this.openMessage({
            content: this.lang.logProgressError || '',
            delay: 10000
        });
    };

    Notifications.prototype.offline = function() {
        if (!this.modal) {
            return;
        }

        this.openMessage({
            type: 'modal',
            content: this.lang.connectionOffline || '',
            showClose: false,
            overlay: true,
            button: true
        });
    };

    Notifications.prototype.online = function() {
        this.dataContext.logProgress('sync');

        if (!this.modal) {
            return;
        }

        this.openMessage({
            type: 'modal',
            content: this.lang.connectionOnline || '',
            showClose: false,
            overlay: true,
            button: true
        });
    };

    Notifications.prototype.errorSCORMInit = function() {
        if (!this.modal) {
            return;
        }

        this.openMessage({
            type: 'modal',
            content: this.lang.scormInitializeError,
            showClose: false,
            overlay: true,
            button: true
        });
    };

    Notifications.prototype.errorSCORMComm = function() {
        if (!this.modal) {
            return;
        }

        this.openMessage({
            type: 'modal',
            content: this.lang.scormCommunicationError,
            showClose: false,
            overlay: true,
            button: true
        });
    };

    Notifications.prototype.authentication = function() {
        var _this = this;

        fetch(this.request).then(function(response) {
            if (response.status === 401 || response.ok === false) {
                _this.openMessage({
                    content: _this.lang.sessionTimeout
                });
            } else {
                setTimeout(_this.authentication.bind(this), _this.interval);
            }
        });
    };

    Notifications.prototype.init = function() {

        window.addEventListener('online', this.online, false);

        window.addEventListener('offline', this.offline, false);

        window.addEventListener('log-error', this.error, false);

        window.addEventListener('log-error-LMSInitialize', this.errorSCORMInit, false);

        window.addEventListener('log-error-LMSCommunication', this.errorSCORMComm, false);

        if (training.scormPackage) {

            require(['scormPackage', 'user-answers'], function(ScormPackage, UserAnswers) {
                var scormPackage = new ScormPackage(),
                    userAnswers = new UserAnswers();

                window.onpagehide = window.onunload = window.onbeforeunload = function() {
                    // Set lesson status once again for to be sure it's stored
                    scormPackage.setLessonStatus(userAnswers, true);
                    scormPackage.quit();
                    return;
                };
            });

        } else if (!training.offlinePackage) {

            setTimeout(this.authentication, this.interval);
        }
    };

    return function(options) {

        if (!notifications) {
            dialog = new Dialog();
            training = new Training();

            notifications = new Notifications(options);
        }

        return notifications;
    };

});

